<template>
  <div class="menu-form-container">
    <v-card flat>
      <v-card-text class="pa-6">
        <v-form ref="menuForm" v-model="isValid" @submit.prevent="save">
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center mb-4">
                <v-icon color="primary" class="mr-2">mdi-food-fork-drink</v-icon>
                <span class="text-h6 font-weight-medium">Información del Menú Comandero</span>
              </div>
            </v-col>

            <v-col cols="12" md="12">
              <v-text-field v-model="formData.nm" label="Nombre del Menú"
                placeholder="Ej. Menú Principal, Bebidas, Desayunos" outlined dense
                prepend-inner-icon="mdi-format-title" :rules="[v => !!v || 'El nombre es requerido']"
                @keyup.enter="save"></v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-autocomplete v-model="formData.in" :items="categorias" item-text="Nombre" item-value="id"
                label="Categorías" multiple chips deletable-chips outlined dense prepend-inner-icon="mdi-tag-multiple"
                :rules="[v => v.length > 0 || 'Seleccione al menos una categoría']"></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4 sticky-actions">
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('toggle', false)" class="text-none">
          Cancelar
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!isValid" elevation="0" class="px-8 text-none">
          Guardar Menú
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "MenusComanderoForm",
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    dataEdit: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isValid: true,
      categorias: [],
      formData: {
        id: null,
        nm: "",
        in: []
      }
    };
  },
  mounted() {
    if (this.edit && this.dataEdit) {
      this.formData = { ...this.dataEdit };
      this.formData.id = this.dataEdit.Id || this.dataEdit.id || null;
      this.formData.nm = this.dataEdit.nm || this.dataEdit.Nombre || "";
      this.formData.in = this.dataEdit.in || [];
    }
    this.getCategories();
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.categorias = await this.fetchCategories();
    },
    save() {
      if (this.$refs.menuForm.validate()) {
        const mode = this.edit ? "EDIT" : "CREATE";
        if (mode === "CREATE") {
          this.formData.id = null;
        }
        this.$emit("successData", { ...this.formData }, mode);
      }
    }
  }
};
</script>

<style scoped>
.menu-form-container {
  background-color: #fcfcfc;
}

.sticky-actions {
  position: sticky;
  bottom: 0px;
  background-color: white !important;
  z-index: 10;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
